<template>
  <div class="rfp-product-level-product_id-varint_id">
    <template v-if="productItemId === ''">{{ productItemIdEmpty }}</template>
    <template v-if="varintItemId === ''">{{ varintItemIdEmpty }}</template>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';

export default {
  name: 'rfp-mctb-brand',
  props: {
    productItemId: {
      type: String,
      required: true,
    },
    varintItemId: {
      type: String,
      required: true,
    },
    productItemIdEmpty: {
      type: String,
      default: 'Product id missing',
    },
    varintItemIdEmpty: {
      type: String,
      default: 'Variant id missing',
    },
    dataLayerExtraParams: {
      type: Object,
      default: () => ({ empty: true }),
    },
  },
  created() {
    if (this.dataLayerExtraParams) {
      eventBus.emit('rfp-mctb-extra-params-component', this.dataLayerExtraParams);
    }
    eventBus.on('rfp-mctb-has-variant-component1', () => {
      eventBus.emit('rfp-mctb-has-variant-component', {
        productItemId: this.productItemId,
        varintItemId: this.varintItemId,
      });
    });
  },
};
</script>
